import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="bg-[#0f1e35] text-white">

            <div className="border-t border-[#0f1e35]">
                <div className="max-w-screen-xl mx-auto px-6 py-6 text-center text-blue-200">© {new Date().getFullYear()} Effortless English. All rights reserved.</div>
            </div>
        </footer>
    );
}
